<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>